import React from "react";

function JoinderRequest() {
  return <div>JoinderRequest JoinderRequest</div>;
}

export default JoinderRequest;
